import React, { useState, useEffect } from "react";
import Company from "./company";
import { getCompanyPreparedData } from "./utils";

const RootTree = ({ addresses, form }) => {
	const { getFieldValue, setFieldsValue } = form;
	const [selectedHouses, setSelectedHouses] = useState([]);
	const [preparedData, setPreparedData] = useState([]);

	useEffect(() => {
		const selectedHouses = getFieldValue('addresses').reduce((acc, val, index) => {
			if (val) {
				acc.push(index);
			}

			return acc;
		}, []);

		setSelectedHouses(selectedHouses);
	}, []);

	useEffect(() => {
		const preparedData = getCompanyPreparedData(
			addresses,
			selectedHouses,
			setFieldsValue,
			setSelectedHouses
		);
		setPreparedData(preparedData);
	}, [selectedHouses]);

	return preparedData.map((companyObj) => {
		return (
			<Company key={companyObj?.company} company={companyObj} />
		);
	});
};

export default RootTree;
